<div class="heatmap-container">
  @if (TopLabel != '') {
    <div class="label left" style="color:white;">
      {{TopLabel}}
    </div>
  }
  @if (BottomLabel != '') {
    <div class="label right" style="color:white;">
      {{BottomLabel}}
    </div>
  }
  <canvas #canvasElement class="canvas" [width]="width" [height]="height"></canvas>
</div>